module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Regular.03676981.otf";